// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__BPsHz","button":"styles_button__Y48YQ"};